@if (loading) {
  <div class="idv-loading-background">
    <spinner></spinner>
  </div>
} @else {
  <div class="routed-component-layout">
      @if (!tokenVerified) {
        <div class="token-expired routed-component-body">
          <div class="routed-component-title-block">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M32.0003 6.66699C32.0003 5.56242 31.1049 4.66699 30.0003 4.66699C28.8958 4.66699 28.0003 5.56242 28.0003 6.66699V13.3337C28.0003 14.4382 28.8958 15.3337 30.0003 15.3337C31.1049 15.3337 32.0003 14.4382 32.0003 13.3337V6.66699ZM67.3419 12.6586C61.3539 6.67053 51.6453 6.67053 45.6573 12.6586L38.5862 19.7296C37.8052 20.5107 37.8052 21.777 38.5862 22.5581C39.3673 23.3391 40.6336 23.3391 41.4147 22.5581L48.4857 15.487C52.9117 11.0611 60.0875 11.0611 64.5135 15.487C68.9394 19.9129 68.9394 27.0888 64.5135 31.5148L57.4424 38.5858C56.6614 39.3669 56.6614 40.6332 57.4424 41.4142C58.2235 42.1953 59.4898 42.1953 60.2708 41.4142L67.3419 34.3432C73.3299 28.3551 73.3299 18.6466 67.3419 12.6586ZM13.0812 10.2528C12.3002 9.47173 11.0338 9.47173 10.2528 10.2528C9.47173 11.0338 9.47173 12.3002 10.2528 13.0812L14.9668 17.7953C15.7479 18.5763 17.0142 18.5763 17.7953 17.7953C18.5763 17.0142 18.5763 15.7479 17.7953 14.9668L13.0812 10.2528ZM53.0812 29.7478C53.8623 28.9668 53.8623 27.7004 53.0812 26.9194C52.3002 26.1383 51.0338 26.1383 50.2528 26.9194L26.9194 50.2527C26.1384 51.0338 26.1384 52.3001 26.9194 53.0811C27.7005 53.8622 28.9668 53.8622 29.7479 53.0811L53.0812 29.7478ZM6.66699 28.0003C5.56242 28.0003 4.66699 28.8958 4.66699 30.0003C4.66699 31.1049 5.56242 32.0003 6.66699 32.0003H13.3337C14.4382 32.0003 15.3337 31.1049 15.3337 30.0003C15.3337 28.8958 14.4382 28.0003 13.3337 28.0003H6.66699ZM22.5585 41.4142C23.3395 40.6332 23.3395 39.3669 22.5585 38.5858C21.7774 37.8048 20.5111 37.8048 19.73 38.5858L12.659 45.6569C6.67094 51.6449 6.67094 61.3535 12.659 67.3415C18.647 73.3295 28.3556 73.3295 34.3436 67.3415L41.4147 60.2704C42.1957 59.4894 42.1957 58.223 41.4147 57.442C40.6336 56.6609 39.3673 56.6609 38.5862 57.442L31.5152 64.5131C27.0892 68.939 19.9133 68.939 15.4874 64.5131C11.0615 60.0871 11.0615 52.9113 15.4874 48.4853L22.5585 41.4142ZM66.667 48.0003C65.5624 48.0003 64.667 48.8958 64.667 50.0003C64.667 51.1049 65.5624 52.0003 66.667 52.0003H73.3337C74.4382 52.0003 75.3337 51.1049 75.3337 50.0003C75.3337 48.8958 74.4382 48.0003 73.3337 48.0003H66.667ZM65.0339 62.2051C64.2529 61.424 62.9866 61.424 62.2055 62.2051C61.4245 62.9861 61.4245 64.2525 62.2055 65.0335L66.9196 69.7476C67.7006 70.5286 68.9669 70.5286 69.748 69.7476C70.529 68.9665 70.529 67.7002 69.748 66.9191L65.0339 62.2051ZM52.0003 66.667C52.0003 65.5624 51.1049 64.667 50.0003 64.667C48.8958 64.667 48.0003 65.5624 48.0003 66.667V73.3337C48.0003 74.4382 48.8958 75.3337 50.0003 75.3337C51.1049 75.3337 52.0003 74.4382 52.0003 73.3337V66.667Z"/>
              </svg>
            </div>
            <h5><strong>{{ "REGISTRATION.INT_USER_IDV_PAGE.EXPIRED_TITLE" | translate }}</strong></h5>
          </div>
          <p>
            {{ "REGISTRATION.INT_USER_IDV_PAGE.EXPIRED_PARAGRAPH" | translate }}
          </p>
        </div>
      }

      @if (idvUserForm) {
        <form [formGroup]="idvUserForm" (ngSubmit)="submitDetailsForm()">
          <div class="routed-component-body">
            <div class="routed-component-title-block">
              <h2>{{ "REGISTRATION.INT_USER_IDV_PAGE.TITLE" | translate }}</h2>
              <p>{{ "REGISTRATION.INT_USER_IDV_PAGE.IDV_PARAGRAPH" | translate }}</p>
            </div>
            <div class="field-group-layout">
              <h5><strong>{{ 'REGISTRATION.INT_USER_IDV_PAGE.PERSONAL_INFORMATION' | translate }}</strong></h5>

              <soldo-field-layout
                [control]="idvUserForm.controls.firstName"
                fieldName="firstName"
                cypressSelector="IdvUser_TextInput_FirstName"
                label="REGISTRATION.INT_USER_IDV_PAGE.FIRST_NAME_LABEL">
                <input input type="text" name="firstName" [readonly]="true" [value]="sessionData?.firstName" />
              </soldo-field-layout>

              <soldo-field-layout
                [control]="idvUserForm.controls.middleName"
                fieldName="middleName"
                cypressSelector="IdvUser_TextInput_MiddleName"
                label="REGISTRATION.INT_USER_IDV_PAGE.MIDDLE_NAME_LABEL">
                <input input type="text" name="middleName" [readonly]="true" [value]="sessionData?.middleName" />
              </soldo-field-layout>

              <soldo-field-layout
                [control]="idvUserForm.controls.lastName"
                fieldName="lastName"
                cypressSelector="IdvUser_TextInput_LastName"
                label="REGISTRATION.INT_USER_IDV_PAGE.LAST_NAME_LABEL">
                <input input type="text" name="lastName" [readonly]="true" [value]="sessionData?.lastName" />
              </soldo-field-layout>

              <soldo-field-layout
                [control]="idvUserForm.controls.dateOfBirth"
                fieldName="dateOfBirth"
                cypressSelector="IdvUser_TextInput_DateOfBirth"
                label="REGISTRATION.INT_USER_IDV_PAGE.DATE_OF_BIRTH_LABEL">

                <input input type="text" name="dateOfBirth"
                  formControlName="dateOfBirth"
                  mask="00/00/0000"
                  [validation]="false"
                  [specialCharacters]="[ '/' ]"
                  [dropSpecialCharacters]="false"
                  placeholder="{{ 'REGISTRATION.INT_USER_IDV_PAGE.DATE_OF_BIRTH_PLACEHOLDER' | translate }}" />

                <ng-container errorMessage>
                  <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
                  <soldo-field-error errorName="invalidDateFormat">{{ 'DATE_FORMAT_ERROR' | translate }}</soldo-field-error>
                  <soldo-field-error errorName="ageNotAllowed">{{ 'DATE_AGE_NOT_ALLOWED' | translate }}</soldo-field-error>
                </ng-container>
              </soldo-field-layout>

              <soldo-field-layout
                [control]="idvUserForm.controls.nationality"
                fieldName="nationality"
                cypressSelector="IdvUser_NgSelect_Nationality"
                label="REGISTRATION.INT_USER_IDV_PAGE.NATIONALITY_LABEL">

                <ng-select input name="nationality"
                  formControlName="nationality"
                  [items]="completeCountryList"
                  bindLabel="name"
                  bindValue="iso3"
                  [clearable]="false"
                  notFoundText="{{'NO_ITEMS_FOUND' | translate }}">
                </ng-select>
                <ng-container errorMessage>
                  <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
                </ng-container>
              </soldo-field-layout>

              <h5><strong>{{ 'REGISTRATION.INT_USER_IDV_PAGE.ADDRESS_TITLE' | translate }}</strong></h5>

            <address3-form-group
                [readonly]="false"
                [addressFormGroup]="idvUserForm.controls.address"
                [translatedCountries]="translatedCountries"
                data-cy="IdvUser_Address_ResidentialAddress" />

              <h5><strong>{{ 'REGISTRATION.INT_USER_IDV_PAGE.CODICE_FISCALE_TITLE' | translate }}</strong></h5>

              <div>
              @if (idvUserForm.controls.codiceFiscaleChoice) {
                <soldo-field-layout
                  [control]="idvUserForm.controls.codiceFiscaleChoice"
                  fieldName="codiceFiscaleChoice"
                  cypressSelector="IdvUser_RadioButton_CodiceFiscaleChoice"
                  label="REGISTRATION.INT_USER_IDV_PAGE.CODICE_FISCALE_QUESTION">

                  <fieldset input id="codiceFiscaleChoiceRadio">
                    <legend>-- (hidden) need this to group the choices when multiple admin forms are on screen --</legend>
                    <div data-cy="IdvUser_RadioButton_CodiceFiscaleChoice_NO">
                      <input id="codiceFiscaleChoiceRadio-NO" type="radio" formControlName="codiceFiscaleChoice" [value]="false">
                      <label for="codiceFiscaleChoiceRadio-NO">{{ 'REGISTRATION.INT_USER_IDV_PAGE.CODICE_FISCALE_NO' | translate }}</label>
                    </div>
                    <div data-cy="IdvUser_RadioButton_CodiceFiscaleChoice_YES">
                      <input id="codiceFiscaleChoiceRadio-YES" type="radio" formControlName="codiceFiscaleChoice" [value]="true">
                      <label for="codiceFiscaleChoiceRadio-YES">{{ 'REGISTRATION.INT_USER_IDV_PAGE.CODICE_FISCALE_YES' | translate }}</label>
                    </div>
                  </fieldset>

                  <ng-container errorMessage>
                    <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
                  </ng-container>
                </soldo-field-layout>
              }

              @if (idvUserForm.controls.codiceFiscale) {
                <div [ngClass]="{'conditional-subfield-container': idvUserForm.value?.codiceFiscaleChoice}">
                  <soldo-field-layout
                    [control]="idvUserForm.controls.codiceFiscale"
                    fieldName="codiceFiscale"
                    cypressSelector="IdvUser_TextInput_CodiceFiscale"
                    label="REGISTRATION.INT_USER_IDV_PAGE.CODICE_FISCALE_ITA_LABEL">

                      <input input type="text" name="codiceFiscale"
                        formControlName="codiceFiscale"
                        uppercase>

                      <ng-container errorMessage>
                        <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
                        <soldo-field-error error errorName="wrongFormat">{{ 'WRONG_FORMAT' | translate }}</soldo-field-error>
                        <soldo-field-error error errorName="nameCfMismatch">
                          {{ 'REGISTRATION.INT_USER_IDV_PAGE.NAME_CF_MISMATCH' | translate }}
                        </soldo-field-error>
                        <soldo-field-error error errorName="dateCfMismatch">
                          {{ 'REGISTRATION.INT_USER_IDV_PAGE.DATE_CF_MISMATCH' | translate }}
                        </soldo-field-error>
                        <soldo-field-error error errorName="ageNotAllowed">{{ 'DATE_AGE_NOT_ALLOWED' | translate }}</soldo-field-error>
                      </ng-container>
                  </soldo-field-layout>
                </div>
              }
              </div>

            </div>
            <div class="navigation-controls-layout">
              <div class="idv-cta-section">
                <button data-cy="IDV_Button_VerifyYourIdentityButton" class="primary" type="submit">
                  {{ "REGISTRATION.INT_USER_IDV_PAGE.CTA" | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      }
  </div>
}
